import { DashValue } from 'src/modules/valves/ValveCard/DashValue.ts';
import { AttributesList } from 'src/utils/createAttributesItem.ts';
import { filterEmpty } from 'src/utils/filterEmpty.ts';
import { ActuatorProduct } from 'src/actuators/list/ActuatorsListPageMapping.ts';
import { combine } from 'src/utils/combine.ts';
import { AttributesAliases } from 'src/generated/dict.ts';
import { MESSAGES } from 'src/modules/common/constants.ts';

export function prepareActuatorAttributes(
    product: ActuatorProduct,
    addFailSafe: boolean,
): [AttributesList, AttributesList] {
    let attrs: [AttributesList, AttributesList] = [
        [
            [MESSAGES.ActuatorsHomePageTypesTitle, product.family || DashValue],
            [AttributesAliases.torque, product.torque],
            [AttributesAliases.actuatingForce, product.actuatingForce],
            [AttributesAliases.nominalVoltage, product.nominalVoltage || DashValue],
            [AttributesAliases.controlType, product.controlType || DashValue],
            [AttributesAliases.runningTime, product.runningTime || DashValue],
        ], [
            [AttributesAliases.stroke, product.stroke],
            [AttributesAliases.protection, product.protection || DashValue],
            [AttributesAliases.integratedSwitch, product.integratedSwitch || DashValue],
            [AttributesAliases.electricalConnection, product.electricalConnection || DashValue],
        ]];
    if ('torqueInLb' in product) {
        attrs = [
            [
                [MESSAGES.ActuatorsHomePageTypesTitle, product.family || DashValue],
                [AttributesAliases.torque, combine(product.torqueInLb, product.torque)],
                [AttributesAliases.actuatingForce, combine(product.actuatingForceLbf, product.actuatingForce)],
                [AttributesAliases.nominalVoltage, product.nominalVoltage || DashValue],
                [AttributesAliases.controlType, product.controlType || DashValue],
                [AttributesAliases.runningTime, product.runningTime || DashValue],
            ], [
                [AttributesAliases.stroke, product.stroke],
                [AttributesAliases.protection, product.protection || DashValue],
                [AttributesAliases.integratedSwitch, product.integratedSwitch || DashValue],
                [AttributesAliases.electricalConnection, product.electricalConnection || DashValue],
            ]];
    }
    if (addFailSafe) {
        attrs[0].push([AttributesAliases.failSafeFunction, product.failSafeFunction || DashValue]);
    }
    return [attrs[0].filter(filterEmpty), attrs[1].filter(filterEmpty)];
}
